import React from "react";

// Global safety net: prevents any single render error from blanking the whole app.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App render error caught by ErrorBoundary:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6"
        >
          <div className="max-w-md w-full bg-[#141414] border border-white/10 rounded-2xl p-8 text-center">
            <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#C41E24] mb-3">
              Next O Soccer
            </div>
            <h1 className="font-headings text-2xl uppercase tracking-wide mb-2">
              Something went wrong
            </h1>
            <p className="text-sm text-white/50 mb-6">
              The screen hit an unexpected error. Your data is safe — try again or head back to your dashboard.
            </p>
            <div className="flex items-center justify-center gap-3">
              <button
                data-testid="error-retry-btn"
                onClick={this.handleReset}
                className="bg-[#C41E24] hover:bg-[#A0161D] text-white text-xs font-bold uppercase tracking-wider px-5 py-2.5 rounded-md transition-colors"
              >
                Try Again
              </button>
              <button
                data-testid="error-home-btn"
                onClick={() => { window.location.href = "/hub"; }}
                className="border border-white/15 hover:border-white/40 text-white/80 text-xs font-bold uppercase tracking-wider px-5 py-2.5 rounded-md transition-colors"
              >
                Go to Hub
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
